<template>
    <div>
        <main id="content" role="main">
            <!-- Login Form -->
            <div class="container space-2">
                <form @submit="submit_form" class="js-validate w-md-75 w-lg-50 mx-md-auto">
                    <!-- Title -->
                    <div class="mb-7">
                        <h2 class="h3 text-primary font-weight-normal mb-0">Bien<span class="font-weight-semi-bold">venue</span></h2>
                        <p>Connectez vous pour gérer votre compte.</p>
                    </div>
                    <!-- End Title -->

                    <!-- Form Group -->
                    <div class="js-form-message form-group">
                        <label class="form-label" for="signinSrEmail">Addresse e-mail</label>
                        <input v-model="email" type="email" class="form-control" name="email" id="signinSrEmail"
                               placeholder="Addresse e-mail" aria-label="Addresse e-mail" required
                               data-msg="Veuillez entre une adresse e-mail valide."
                               data-error-class="u-has-error"
                               data-success-class="u-has-success"
                        >
                    </div>
                    <!-- End Form Group -->

                    <!-- Form Group -->
                    <div class="js-form-message form-group">
                        <label class="form-label" for="signinSrPassword">
                            <span class="d-flex justify-content-between align-items-center">
                              Mot de passe
                                <router-link class="link-muted text-capitalize font-weight-normal"
                                             :to="{'name': 'recoverAccount'}">
                                  Mot de passe oublié?
                                </router-link>
                            </span>
                        </label>
                        <input v-model="password" type="password" class="form-control" name="password"
                               id="signinSrPassword" placeholder="********" aria-label="********" required
                               data-msg="Votre mot de passe est incorrect, veuillez réessayer."
                               data-error-class="u-has-error"
                               data-success-class="u-has-success"
                        >
                    </div>
                    <!-- End Form Group -->

                    <!-- Submit Errors -->
                    <div class="mb-7">
                        <p v-if="error" class="text-danger">{{ error }}</p>
                    </div>
                    <!-- End Submit Errors -->

                    <!-- Button -->
                    <div class="row align-items-center mb-5">
                        <div class="col-6">
                            <span class="small text-muted">Vous n'avez pas encore de compte?</span>
                            <router-link class="small" :to="{'name': 'signup'}">S'inscrire</router-link>
                        </div>

                        <div class="col-6 text-right">
                            <LoadingButton v-if="requestIsLoading"/>
                            <button v-else type="submit" class="btn btn-primary transition-3d-hover">Se connecter</button>
                        </div>
                    </div>
                    <!-- End Button -->

                </form>
            </div>
            <!-- End Login Form -->
        </main>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'
    import { GET_TOKEN } from '@/settings/graphql'
    import LoadingButton from "@/components/LoadingButton";
    import {errorMessageDisplay} from "@/xlib/graphql";

    export default {
        name: "LogIn",
        components: {LoadingButton},
        data() {
            return {
                email: "",
                password: "",
                error: null,
                requestIsLoading: false
            };
        },
        methods: {
            ...mapMutations([
                'setUserAuthToken'
            ]),
            saveAuthToken(authToken) {
                this.setUserAuthToken(authToken);
            },
            submit_form(event) {
                // console.log("Login form submission...");
                event.preventDefault();
                this.$data.requestIsLoading = true;
                const { email, password } = this.$data;
                this.$apollo.mutate({
                    mutation: GET_TOKEN,
                    variables: {email, password}
                }).then((result) => {
                    let token = result.data.tokenAuth.token;
                    this.saveAuthToken(token);
                    // console.log("Token saved...");
                    this.$router.push({ name: 'home'});
                    // console.log("We are on home page now...");
                }).catch((error) => {
                    // console.log(JSON.stringify(error));
                    this.$data.error = errorMessageDisplay(error);
                    this.$data.requestIsLoading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>